import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteUser, removeUser } from "../../../axios/User/UserApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import { useAuth } from "../../../context/AuthContext";

const RemoveUserDialog = ({ isDelete = false, info, onRefresh, onClose }) => {
  const { t } = useTranslation();
  const { ownerId } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleRemoveUser = async () => {
    setLoading(true);
    try {
      const langId = localStorage.getItem("i18nextLngId");
      const payload = { ownerId };
      if (isDelete) {
        await deleteUser(info.userId, langId, payload);
      } else {
        await removeUser(info.userId, langId, payload);
      }

      toast.success(t("common.content-082"));
      onClose();
      onRefresh?.();
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant={isDelete ? "delete" : "warning"}
      title={
        isDelete
          ? t("common.content-149")
          : t("common.are-you-sure-you-want-to-remove-this-user")
      }
      subtitle={
        isDelete ? undefined : t("common.once-removed-user-will-not-be-showing")
      }
      confirmText={isDelete ? t("button.delete") : t("button.confirm")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleRemoveUser}
    />
  );
};

export default RemoveUserDialog;
